import { gql } from '@apollo/client';

export const GET_ALL_MANAGERS = gql`
  query GetAllManagers {
    vm {
      admins {
        ...NotificationManagerInfo
      }
    }
  }
  fragment NotificationManagerInfo on VOLUNTEER_ManagerType {
    managerId
    profile {
      profileId
      userId
      preferredName
      lastName
      email
      avatarUrl
      lastLogin {
        ipAddress
        occurredAt
      }
      volunteer {
        volunteerId
      }
    }
  }
`;